import React, { useState, useEffect, useRef } from 'react';
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Paper,
  Chip,
  Typography,
  IconButton,
  TableContainer,
  Tooltip,
  Switch,
  Grid,
  Pagination,
} from '@mui/material';
import '../components/css/Users.css';
import colors from '../theme/Colors';
import Navbar from '../components/Navbar';
import { api } from '../helpers/apiRequest';
import CustomSelect from '../components/CustomSelect';
import AddIcon from '@mui/icons-material/Add';
import DeleteIcon from '@mui/icons-material/Delete';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import CancelIcon from '@mui/icons-material/Cancel';
import LocalShippingIcon from '@mui/icons-material/LocalShipping';
import { toast } from 'react-toastify';
import { Payment, RemoveRedEye, Undo } from '@mui/icons-material';
import OrderDetailsDialog from '../components/OrderDetailsDialog';
import { PiCurrencyDollar, PiInvoiceFill } from 'react-icons/pi';
import EditIcon from '@mui/icons-material/Edit';
import ApprovalModal from '../components/ApprovalModal';
import OrderItemsTable from '../components/OrderItemsTable';
import { pageAccessList } from '../helpers/pageAccessList';
import ColorDialogTabs from '../components/ColorDialog';
import ShipOrderModal from '../components/ShipOrderModal';
import PaymentDialog from '../components/PaymentDialog';
// import {sizes} from '../helpers/sizes';

const Orders = () => {
  const [shipModalOpen, setShipModalOpen] = useState(false);
  const [selectedStatus, setSelectedStatus] = useState('');
  const [selectedPayment, setSelectedPayment] = useState('');
  const [selectedInvoice, setSelectedInvoice] = useState('');
  const [fromDate, setFromDate] = useState('');
  const [toDate, setToDate] = useState('');
  const toDateRef = useRef(toDate);
  const fromDateRef = useRef(fromDate);
  const selectedInvoiceRef = useRef(selectedInvoice);
  const selectedPaymentRef = useRef(selectedPayment);
  const selectedStatusRef = useRef(selectedStatus);


  // Open modal for a specific order

  const [user, setUser] = useState(null);
  const [orders, setOrders] = useState([]);
  const [order, setSelectedOrder] = useState({});
  const [customers, setCustomers] = useState([]);
  const [loading, setLoading] = useState(false);
  const [openDialog, setOpenDialog] = useState(false);
  const [parties, setParties] = useState([]);
  const [styles, setStyles] = useState([]);
  const [pStyles, setPStyles] = useState([]);
  const [items, setItems] = useState([]);
  const [openDetailsDialog, setOpenDetailsDialog] = useState(false);
  const [selectedCustomer, setSelectedCustomer] = useState('');
  const [approvalModalOpen, setApprovalModalOpen] = useState(false);
  const [selectedOrderId, setSelectedOrderId] = useState(null);
  const [qstEnabled, setQstEnabled] = useState(false);
  const [gstEnabled, setGstEnabled] = useState(false);
  const [hstEnabled, setHstEnabled] = useState(false);
  const [generateInvoice, setGenerateInvoice] = useState(false);
  const [discount, setDiscount] = useState(0);
  const [approvalRemarks, setApprovalRemarks] = useState("");
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(100);
  const [shippingOrders, setShippingOrders] = useState(new Set());
  const [colors, setColors] = useState([]);
  const customerRef = useRef(selectedCustomer);
  const rppRef = useRef(rowsPerPage);
  const [userInfo] = useState(JSON.parse(localStorage.getItem('user')));
  const [accessControl, setAccessControl] = useState({});
  const fetchCurrentUser = async () => {
    try {
      let user = await localStorage.getItem('user');
      user = JSON.parse(user);

      if (user) {
        const res = await api.get(`/users/get/routes?userId=${userInfo?.id}`);
        const accessArray = res.data.message || [];
        // Map route permissions by route key
        const accessMapFromServer = accessArray.reduce((map, item) => {
          map[item.route] = item.allowed;
          return map;
        }, {});

        // Merge with full pageAccessList to ensure all routes are covered
        const accessMap = pageAccessList.reduce((acc, page) => {
          acc[page.key] = accessMapFromServer[page.key] || false;
          return acc;
        }, {});
        console.log("setAccessControl", accessControl);
        setAccessControl(accessMap);
      }
    } catch (error) {
      console.log(error);
    }
  }
  useEffect(() => {
    fetchCurrentUser();
  }, []);
  useEffect(() => {
    customerRef.current = selectedCustomer;
  }, [selectedCustomer]);
  useEffect(() => {
    rppRef.current = rowsPerPage;
  }, [rowsPerPage]);
  useEffect(() => {
    toDateRef.current = toDate;
  }, [toDate]);
  useEffect(() => {
    fromDateRef.current = fromDate;
  }, [fromDate]);
  useEffect(() => {
    selectedInvoiceRef.current = selectedInvoice;
  }, [selectedInvoice]);
  useEffect(() => {
    console.log("selected payment:", selectedPayment);
    selectedPaymentRef.current = selectedPayment;
  }, [selectedPayment]);
  useEffect(() => {
    selectedStatusRef.current = selectedStatus;
  }, [selectedStatus]);
  const [colorDialog, setColorDialog] = useState({
    open: false,
    name: ''
  });

  const [partySpecificOptions, setPartySpecificOptions] = useState({});
  const [orderForms, setOrderForms] = useState([
    {
      customerId: user?.role === 'customer' ? user?.id : '',
      party: '',
      p_style: '',
      style: '',
      item: '',
      items: []
    }
  ]);
  const [selectedOrderCustomer, setSelectedOrderCustomer] = useState('');
  const [isEditing, setIsEditing] = useState(false);
  const [editOrderId, seteditOrderId] = useState(null);


  useEffect(() => { }, [order]);
  const ENDPOINTS = {
    getOrders: 'orders/orders',
    getCustomerOrders: 'orders/orders_by_cust',
    AddOrder: 'orders/place',
    getStock: 'inventory/stocklist',
    getcustomers: 'users/users/role/customer',
    approveOrder: 'orders/approve',
    cancelOrder: 'orders/cancel',
    shipOrder: 'orders/ship',
    downloadInvoice: 'orders/invoice',
    getParties: 'inventory/party',
    getPStyles: 'inventory/pstyles',
    getStyles: 'inventory/styles',
    getItems: 'inventory/items',
    getColors: 'inventory/colors',
    addColor: 'inventory/color',
    getPrice: 'inventory/price',
    UpdateOrder: 'orders/order',
  };
  const downloadInvoice = async (order) => {
    try {
      let user = JSON.parse(localStorage.getItem('user'));
      let token = user?.token;

      const response = await api.post(
        ENDPOINTS.downloadInvoice,
        { orderId: order?.orderId },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
          responseType: 'blob',
        }
      );


      // if (response.status) {
      //   const blob = new Blob([response.data], { type: 'application/pdf' });
      //   const url = window.URL.createObjectURL(blob);

      //   const link = document.createElement('a');
      //   link.href = url;
      //   link.download = `invoice_${order?.orderId}.pdf`;
      //   document.body.appendChild(link);
      //   link.click();


      //   document.body.removeChild(link);
      //   window.URL.revokeObjectURL(url);

      //   fetchOrders(rppRef.current, customerRef?.current);
      // } else {
      //   console.error('Failed to download invoice:', response);
      //   toast.error('Failed to download invoice');
      // }
      if (response.status) {
        const blob = new Blob([response.data], { type: 'application/pdf' });
        const url = window.URL.createObjectURL(blob);

        // ✅ Download the file
        const link = document.createElement('a');
        link.href = url;
        link.download = `invoice_${order?.orderId}.pdf`;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);

        // ✅ Open in new tab
        window.open(url, '_blank');

        // Cleanup URL object
        window.URL.revokeObjectURL(url);

        fetchOrders(rppRef.current, customerRef?.current);
      } else {
        console.error('Failed to download invoice:', response);
        toast.error('Failed to download invoice');
      }

    } catch (error) {
      console.error('Error downloading invoice:', error.message);
      toast.error('Error downloading invoice. Please try again.');
    }
  };

  useEffect(() => {
    const initUser = async () => {
      const userData = await localStorage.getItem('user');
      const parsedUser = JSON.parse(userData);
      setUser(parsedUser);
    };
    initUser();
  }, []);

  const fetchOrders = async (rppRef = rowsPerPage, selectedCustomerRef, selectedStatusRef, selectedPaymentRef, selectedInvoiceRef, fromDateRef, toDateRef) => {
    setLoading(true);
    try {
      let url;

      const queryParams = new URLSearchParams();
      queryParams.append('page', page);
      queryParams.append('limit', rppRef);
      if (selectedPayment) {
        queryParams.append('payment_status', selectedPayment);
      }
      if (selectedStatus) {
        queryParams.append('status', selectedStatus);
      }
      if (fromDate) {
        queryParams.append('fromDate', fromDate);
      }
      if (toDate) {
        queryParams.append('toDate', toDate);
      }
      if (selectedInvoice) {
        if (selectedInvoice === 'YES') {
          queryParams.append('invoice_gen', true);
        } else if (selectedInvoice === 'NO') {
          queryParams.append('invoice_gen', false);
        }

      }



      if (userInfo?.role === 'customer') {

        queryParams.append('customer', userInfo?.id);
        url = `${ENDPOINTS.getCustomerOrders}?${queryParams.toString()}`;
      } else {
        console.log("user?.role:", userInfo?.role);
        console.log("i am here in else part:", selectedCustomerRef.current);
        if (selectedCustomerRef) {
          queryParams.append('customer', selectedCustomerRef);
        }
        url = `${selectedCustomerRef ? ENDPOINTS.getCustomerOrders : ENDPOINTS.getOrders}?${queryParams.toString()}`;
      }
      const response = await api.get(url);
      setOrders(response.data.data || []);
      setTotalPages(Math.ceil(response.data.total_count / rppRef));
    } catch (error) {
      toast.error('Error fetching orders');
    } finally {
      setLoading(false);
    }
  };

  const fetchParties = async () => {
    try {
      const response = await api.get(ENDPOINTS.getParties);
      setParties(response.data.message || []);
    } catch (error) {
      toast.error('Error fetching parties');
    }
  };

  const fetchPStyles = async () => {
    try {
      const response = await api.get(ENDPOINTS.getPStyles);
      setPStyles(response.data.message || []);
    } catch (error) {
      toast.error('Error fetching p-styles');
    }
  };

  const fetchStyles = async () => {
    try {
      const response = await api.get(ENDPOINTS.getStyles);
      setStyles(response.data.message || []);
    } catch (error) {
      toast.error('Error fetching styles');
    }
  };

  const fetchItems = async () => {
    try {
      const response = await api.get(ENDPOINTS.getItems);
      setItems(response.data.message || []);
    } catch (error) {
      toast.error('Error fetching items');
    }
  };

  const fetchCustomers = async () => {
    try {
      const response = await api.get(ENDPOINTS.getcustomers);
      const customersData = response.data.data || [];
      setCustomers(customersData);
    } catch (error) {
      toast.error('Error fetching customers');
      console.error('Error fetching customers:', error);
    }
  };

  useEffect(() => {
    if (user) {
      fetchOrders(rppRef.current, customerRef?.current);
      fetchDropdownData();
      fetchParties();
      fetchPStyles();
      fetchStyles();
      fetchItems();
      if (user.role !== 'customer') {
        fetchCustomers();
      }
    }
  }, [selectedCustomer, user, page, rowsPerPage]);
  useEffect(() => {
    fetchOrders(rppRef.current, customerRef?.current, selectedStatusRef?.current, selectedPaymentRef?.current, selectedInvoiceRef.current, fromDateRef?.current, toDateRef?.current);
  }, [selectedCustomer, selectedStatus, selectedPayment, selectedInvoice, fromDate, toDate]);
  useEffect(() => {
    // const interval = setInterval(() => {
    //   if (user) {
    //     fetchOrders(rppRef.current, customerRef?.current);
    //     fetchDropdownData();
    //     fetchParties();
    //     fetchPStyles();
    //     fetchStyles();
    //     fetchItems();
    //     if (user.role !== 'customer') {
    //       fetchCustomers();
    //     }
    //   }
    // }, 10000); // 10000ms = 10 seconds

    // // Cleanup interval on unmount
    // return () => clearInterval(interval);
  }, []);
  useEffect(() => {
    // const interval = setInterval(() => {
    //   fetchOrders(rppRef.current, customerRef?.current);
    // }, 10000); // 10000ms = 10 seconds
    // // Cleanup interval on unmount
    // return () => clearInterval(interval);
  }, []);



  const validateHeaderFields = (orderData) => {
    if (!orderData.party) return "Please select a Party first";
    if (!orderData.p_style) return "Please select a P-Style first";
    // if (!orderData.style) return "Please select a Style first";
    if (!orderData.item) return "Please select an Item first";
    return null;
  };


  const handleItemChange = (formIndex, itemIndex, field, value) => {
    setOrderForms(prev => {
      const updatedForms = [...prev];
      const form = { ...updatedForms[formIndex] };
      const item = { ...form.items[itemIndex] };

      item[field] = value;

      const sizes = ['XS', 'S', 'M', 'L', 'XL', '2XL', '3XL', 'MIX'];
      let total = 0;
      for (const size of sizes) {
        const quantity = parseInt(item[size]) || 0;
        total += quantity;
      }
      item.total = total * (item.price || 0);

      // Update the item in the form
      form.items[itemIndex] = item;
      updatedForms[formIndex] = form;
      return updatedForms;
    });
  };
  useEffect(() => {
    console.log("updatedOrderFormIsHere:", orderForms);
  }, [orderForms]);
  const handleOrderFieldChange = async (formIndex, field, value) => {
    console.log("formIndex:", formIndex);
    setOrderForms(prev => {

      const updatedForms = [...prev];
      const form = { ...updatedForms[formIndex] };

      if (field === 'party') {
        form.party = value;
        form.p_style = '';
        form.style = '';
        form.item = '';
        form.items = colors.map(color => ({
          color: color.name,
          S: '',
          M: '',
          L: '',
          XL: '',
          '2XL': '',
          '3XL': '',
          MIX: '',
          S_in_hand: '',
          M_in_hand: '',
          L_in_hand: '',
          XL_in_hand: '',
          '2XL_in_hand': '',
          MIX_in_hand: '',
          price: null,
          total: 0
        }));

        if (value) {
          fetchPartySpecificOptions(value, formIndex);
        }
      } else {
        form[field] = value;
      }

      updatedForms[formIndex] = form;
      return updatedForms;
    });

    const currentForm = orderForms[formIndex];
    console.log("currentForm:", currentForm);
    if (field === 'item' && value && currentForm.party && currentForm.p_style) {
      try {
        const stockPromises = colors.map(color =>
          api.post('/inventory/stockdetails', {
            customer: selectedOrderCustomer,
            party: currentForm.party,
            p_style: currentForm.p_style,
            // style: currentForm.style,
            item: value,
            color: color.name
          }).catch(error => {
            return { data: { data: null } };
          })
        );

        const stockResponses = await Promise.all(stockPromises);
        console.log("stock responses:", stockResponses);
        setOrderForms(prev => {
          console.log("prev", prev);
          const updatedForms = [...prev];
          const form = { ...updatedForms[formIndex] };
          if (form) {
            form.items = colors.map(color => ({
              color: color.name,
              S: '',
              M: '',
              L: '',
              XL: '',
              '2XL': '',
              '3XL': '',
              MIX: '',
              S_in_hand: '',
              M_in_hand: '',
              L_in_hand: '',
              XL_in_hand: '',
              '2XL_in_hand': '',
              MIX_in_hand: '',
              price: null,
              total: 0
            }));
          }
          console.log("form:", form);
          form.items = form.items.map((item, idx) => {
            console.log(idx);
            const stockData = stockResponses[idx].data.data;
            console.log("stockData:", { stockData, idx });
            if (!stockData) {
              return {
                ...item,
                price: 0,
                S_in_hand: 0,
                M_in_hand: 0,
                L_in_hand: 0,
                XL_in_hand: 0,
                '2XL_in_hand': 0,
                MIX_in_hand: 0,
                quantity_in_hand: 0,
                stock: null
              };
            }

            const sizeQuantities = {};
            let totalQuantityInHand = 0;

            stockData.sizes.forEach(sizeData => {
              sizeQuantities[`${sizeData.size}_in_hand`] = sizeData.quantity_in_hand;
              totalQuantityInHand += sizeData.quantity_in_hand;
            });

            return {
              ...item,
              price: stockData.price || 0,
              ...sizeQuantities,
              quantity_in_hand: totalQuantityInHand,
              stock: stockData.stockId
            };
          }).filter(item => item.quantity_in_hand > 0);
          updatedForms[formIndex] = form;
          return updatedForms;
        });

        const availableStocks = stockResponses.filter(response => response.data.data).length;
        if (availableStocks < colors.length) {
          toast.info(`Stock available for ${availableStocks} out of ${colors.length} colors`);
        }

      } catch (error) {
        console.error('Error fetching stock details:', error);
        toast.error('Error fetching stock details');
      }
    }
  };

  const handleAddOrderForm = () => {
    setOrderForms(prev => [...prev, {
      party: '',
      p_style: '',
      style: '',
      item: '',
      items: colors.map(color => ({
        color: color.name,
        S: '',
        M: '',
        L: '',
        XL: '',
        '2XL': '',
        '3XL': '',
        MIX: '',
        S_in_hand: '',
        M_in_hand: '',
        L_in_hand: '',
        XL_in_hand: '',
        '2XL_in_hand': '',
        MIX_in_hand: '',
        price: null,
        total: 0
      }))
    }]);
  };

  const handleRemoveOrderForm = (index) => {
    setOrderForms(prev => prev.filter((_, i) => i !== index));
  };

  const handleOpenDialog = () => {
    setSelectedOrderCustomer(user?.role === 'customer' ? user?.id : '');
    setOrderForms([{
      party: '',
      p_style: '',
      style: '',
      item: '',
      items: colors.map(color => ({
        color: color.name,
        S: '',
        M: '',
        L: '',
        XL: '',
        '2XL': '',
        '3XL': '',
        MIX: '',
        S_in_hand: '',
        M_in_hand: '',
        L_in_hand: '',
        XL_in_hand: '',
        '2XL_in_hand': '',
        MIX_in_hand: '',
        price: null,
        total: 0
      }))
    }]);
    setOpenDialog(true);
  };

  const handleCloseDialog = () => {
    setOpenDialog(false);
    setOrderForms([{
      customerId: user?.role === 'customer' ? user?.id : '',
      party: '',
      p_style: '',
      style: '',
      item: '',
      items: []
    }]);
    setIsEditing(false);
    seteditOrderId(null);
  };


  const handleRemoveItem = (formIndex, itemIndex) => {
    setOrderForms(prev => {
      const updatedForms = [...prev];
      const form = { ...updatedForms[formIndex] };
      form.items = form.items.filter((_, i) => i !== itemIndex);
      updatedForms[formIndex] = form;
      return updatedForms;
    });
  };

  const handleApproveOrder = (orderId) => {
    setSelectedOrderId(orderId);
    setApprovalModalOpen(true);
  };

  const handleApproveOrderWithSettings = async (orderId, settings) => {
    try {
      const response = await api.post(ENDPOINTS.approveOrder, {
        orderId: orderId,
        qst: settings.qst_calculation,
        gst: settings.gst_calculation,
        hst: settings.hst_calculation,
        generateInvoice: settings.invoice_gen,
        discount: settings.discount || 0,
        paid: settings.paid || 0,
        remarks: settings.remarks || ""
      });
      if (response.status === 200 || response.status === 201) {
        toast.success('Order approved successfully');
      }
      // console.log("settings", settings);
      setQstEnabled(settings.qst_calculation);
      setGstEnabled(settings.gst_calculation);
      setHstEnabled(settings.hst_calculation);
      setGenerateInvoice(settings.invoice_gen);
      setDiscount(settings.discount);
      setApprovalRemarks(settings.remarks || "");
      await fetchOrders(rppRef.current, customerRef?.current);
    } catch (error) {
      toast.error('Error approving order.');
      console.error('Error approving order:', error);
    }
  };

  const handleCancelOrder = async (orderId) => {
    try {
      const response = await api.post(ENDPOINTS.cancelOrder, {
        orderId: orderId
      });
      if (response.status === 200) {
        toast.success('Order Reverted successfully');
      }
      fetchOrders(rppRef.current, customerRef?.current);
    } catch (error) {
      toast.success('Error reverting order');
      console.error('Error reverting order:', error);
    }
  };

  // const handleShipOrder = async (orderId) => {
  //   try {
  //     setShippingOrders(prev => new Set(prev).add(orderId));

  //     const response = await api.post(ENDPOINTS.shipOrder, {
  //       orderId: orderId
  //     });

  //     if (response.status === 200 || response.status === 201) {
  //       toast.success('Order Shipped successfully');
  //       fetchOrders(rppRef.current, customerRef?.current);
  //     }
  //   } catch (error) {
  //     toast.error('Error shipping order.');
  //     console.error('Error shipping order:', error);
  //   } finally {
  //     setShippingOrders(prev => {
  //       const newSet = new Set(prev);
  //       newSet.delete(orderId);
  //       return newSet;
  //     });
  //   }
  // };
  const handleShipOrder = async (data) => {
    try {
      setShippingOrders((prev) => new Set(prev).add(selectedOrderId));

      const response = await api.post(ENDPOINTS.shipOrder, {
        orderId: selectedOrderId,
        shipped_date: data.shipped_date,
        shipped_via: data.shipped_via,
      });

      if (response.status === 200 || response.status === 201) {
        toast.success("Order Shipped successfully");
        fetchOrders(rppRef.current, customerRef?.current); // your existing reload
      }
    } catch (error) {
      toast.error("Error shipping order.");
      console.error("Error shipping order:", error);
    } finally {
      setShippingOrders((prev) => {
        const newSet = new Set(prev);
        newSet.delete(selectedOrderId);
        return newSet;
      });
    }
  };
  const getStatusColor = (status) => {
    switch (status) {
      case 'PENDING':
        return 'warning';
      case 'APPROVED':
        return 'info';
      case 'SHIPPED':
        return 'primary';
      case 'DELIVERED':
        return 'success';
      case 'CANCELLED':
        return 'error';
      default:
        return 'default';
    }
  };
  const onOpenDetails = (order) => {
    setSelectedOrder(order);
    setOpenDetailsDialog(true);
  }
  const handleApproveWithSettings = (settings) => {
    handleApproveOrderWithSettings(selectedOrderId, settings);
  };

  const resetApprovalSettings = () => {
    setQstEnabled(false);
    setGstEnabled(false);
    setHstEnabled(false);
    setGenerateInvoice(false);
    setDiscount();
    setApprovalRemarks("");
    setSelectedOrderId(null);
  };

  const handlePageChange = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(1);
  };

  const fetchPartySpecificOptions = async (partyId, formIndex) => {
    try {
      const [pStylesRes, stylesRes, itemsRes] = await Promise.all([
        api.get(`inventory/pstyles_party?party=${partyId}`),
        api.get(`inventory/styles_party?party=${partyId}`),
        api.get(`inventory/items_party?party=${partyId}`)
      ]);

      setPartySpecificOptions(prev => ({
        ...prev,
        [formIndex]: {
          pStyles: pStylesRes.data.message || [],
          styles: stylesRes.data.message || [],
          items: itemsRes.data.message || []
        }
      }));
    } catch (error) {
      console.error('Error fetching party-specific options:', error);
      toast.error('Error fetching options for selected party');
    }
  };

  const fetchDropdownData = async () => {
    try {
      const colorsRes = await api.get(ENDPOINTS.getColors)

      const colorsList = colorsRes.data.message || [];
      setColors(colorsList);

      setOrderForms(prev => prev.map(form => ({
        ...form,
        items: colorsList.map(color => ({
          color: color.name,
          S: '',
          M: '',
          L: '',
          XL: '',
          '2XL': '',
          '3XL': '',
          MIX: '',
          S_in_hand: '',
          M_in_hand: '',
          L_in_hand: '',
          XL_in_hand: '',
          '2XL_in_hand': '',
          MIX_in_hand: '',
          price: null,
          total: 0
        }))
      })));

    } catch (error) {
      console.error('Error fetching dropdown data:', error);
      toast.error('Error fetching data');
    }
  };


  const handleCloseColorDialog = () => {
    setColorDialog({
      open: false,
      name: ''
    });
  };

  const handleAddColor = async () => {
    if (!colorDialog.name.trim()) {
      toast.warn('Color name cannot be empty.');
      return;
    }

    try {
      const response = await api.post(ENDPOINTS.addColor, {
        name: colorDialog.name
      });

      if (response.status === 200 || response.OK) {
        toast.success('Color added successfully');

        // Refresh the color options
        const colorsRes = await api.get(ENDPOINTS.getColors);
        const newColors = colorsRes.data.message || [];
        setColors(newColors);

        // Add new item row with the new color
        setOrderForms(prev => ({
          ...prev,
          items: [
            ...prev.items,
            {
              color: colorDialog.name,
              S: '',
              M: '',
              L: '',
              XL: '',
              '2XL': '',
              '3XL': '',
              MIX: '',
              S_in_hand: '',
              M_in_hand: '',
              L_in_hand: '',
              XL_in_hand: '',
              '2XL_in_hand': '',
              MIX_in_hand: '',
              price: null,
              total: 0
            }
          ]
        }));

        handleCloseColorDialog();
      }
    } catch (error) {
      toast.error('Failed to add color. Please try again.');
      console.error('Error adding color:', error);
    }
  };

  const handleDeleteOrder = async (id) => {
    try {
      await api.delete(`/orders/order-delete/${id}`);
      toast.success('Order deleted successfully');
      
      fetchOrders(rppRef.current, customerRef?.current, selectedStatusRef?.current, selectedPaymentRef?.current, selectedInvoiceRef.current, fromDateRef?.current, toDateRef?.current);
    } catch (error) {
      toast.error(error?.response?.data?.message || 'Failed to delete order');
    }
  };

  const handleAddOrder = async () => {

    if (!selectedOrderCustomer && (user?.role !== 'customer')) {
      toast.error('Please select a customer');
      return;
    }

    const allOrders = [];

    for (const form of orderForms) {
      const validationError = validateHeaderFields(form);
      if (validationError) {
        toast.error(validationError);
        return;
      }

      const itemsWithQuantity = form.items.filter(item => {
        const hasQuantity = ['XS', 'S', 'M', 'L', 'XL', '2XL', '3XL', 'MIX'].some(
          size => item[size] && parseInt(item[size]) > 0
        );
        return hasQuantity;
      });

      if (itemsWithQuantity.length === 0) {
        toast.error('Please enter at least one size quantity');
        return;
      }

      for (const item of itemsWithQuantity) {
        if (!item.stock) {
          toast.error('Stock details not available for some items');
          return;
        }

        for (const size of ['XS', 'S', 'M', 'L', 'XL', '2XL', '3XL', 'MIX']) {
          if (parseInt(item[size]) > item[`${size}_in_hand`]) {
            toast.error(`Quantity exceeds available stock for size ${size}`);
            return;
          }
        }
      }

      allOrders.push({
        items: itemsWithQuantity.map(item => ({
          stock: item.stock,
          S: parseInt(item.S) || 0,
          M: parseInt(item.M) || 0,
          L: parseInt(item.L) || 0,
          XL: parseInt(item.XL) || 0,
          '2XL': parseInt(item['2XL']) || 0,
          '3XL': parseInt(item['3XL']) || 0,

          MIX: parseInt(item.MIX) || 0,
          price: item.price * (parseInt(item.S) || 0 + parseInt(item.M) || 0 + parseInt(item.L) || 0 + parseInt(item.XL) || 0 + parseInt(item['2XL']) || 0 + parseInt(item['3XL']) || 0 + parseInt(item.MIX) || 0) || 0
        }))
      });
    }

    try {
      const mergedOrder = {
        customerId: selectedOrderCustomer,
        items: allOrders.flatMap(order => order.items)
      };

      const response = await api.post(ENDPOINTS.AddOrder, mergedOrder);
      if (!response.status) {
        throw new Error('Failed to create order');
      }

      toast.success('Orders saved successfully');
      await fetchOrders(rppRef.current, customerRef?.current);
      handleCloseDialog();
    } catch (error) {
      toast.error('Error adding orders');
      console.error('Error adding orders:', error);
    }
  };

  const handleUpdateOrder = async () => {
    const allOrders = [];

    for (const form of orderForms) {
      const validationError = validateHeaderFields(form);
      if (validationError) {
        toast.error(validationError);
        return;
      }

      const itemsWithQuantity = form.items.filter(item => {
        const hasQuantity = ['XS', 'S', 'M', 'L', 'XL', '2XL', '3XL', 'MIX'].some(
          size => item[size] && parseInt(item[size]) > 0
        );
        return hasQuantity;
      });

      if (itemsWithQuantity.length === 0) {
        toast.error('Please enter at least one size quantity');
        return;
      }

      for (const item of itemsWithQuantity) {
        if (!item.stock) {
          toast.error('Stock details not available for some items');
          return;
        }

        for (const size of ['XS', 'S', 'M', 'L', 'XL', '2XL', '3XL', 'MIX']) {
          if (parseInt(item[size]) > item[`${size}_in_hand`]) {
            toast.error(`Quantity exceeds available stock for size ${size}`);
            return;
          }
        }
      }

      allOrders.push({
        items: itemsWithQuantity.map(item => ({
          stock: item.stock,
          S: parseInt(item.S) || 0,
          M: parseInt(item.M) || 0,
          L: parseInt(item.L) || 0,
          XL: parseInt(item.XL) || 0,
          '2XL': parseInt(item['2XL']) || 0,
          '3XL': parseInt(item['3XL']) || 0,

          MIX: parseInt(item.MIX) || 0,
          '2XL': parseInt(item['2XL']) || 0,
          price: item.price * (parseInt(item.S) || 0 + parseInt(item.M) || 0 + parseInt(item.L) || 0 + parseInt(item.XL) || 0 + parseInt(item['2XL']) || 0 + parseInt(item['3XL']) || 0 + parseInt(item.MIX) || 0) || 0
        }))
      });
    }

    try {
      const mergedOrder = {
        customerId: selectedOrderCustomer,
        items: allOrders.flatMap(order => order.items)
      };

      const response = await api.put(`${ENDPOINTS.UpdateOrder}/${editOrderId}`, mergedOrder);
      if (!response.status) {
        throw new Error('Failed to update order');
      }

      toast.success('Order updated successfully');
      seteditOrderId(null);
      setIsEditing(false);
      await fetchOrders(rppRef.current, customerRef?.current);
      handleCloseDialog();
    } catch (error) {
      toast.error('Error updating order');
      console.error('Error updating order:', error);
    }
  };
  const handleShipOpen = (order) => {
    setShipModalOpen(true);
    setSelectedOrderId(order?._id);
  }
  const handleEditOrder = (order) => {
    setSelectedOrderCustomer(order.customer._id);

    const groupedItems = order.items.reduce((acc, item) => {
      const key = `${item?.stock?.party?._id}-${item?.stock?.p_style?._id}-${item.stock.item._id}`;
      if (!acc[key]) {
        acc[key] = {
          party: item.stock.party._id,
          p_style: item.stock.p_style._id,
          item: item.stock.item._id,
          items: []
        };
      }
      // acc[key].items.push({
      //   color: item.stock.color,

      //   XS: item.sizes.find(s => s.size === 'XS')?.quantity || '',
      //   S6M: item.sizes.find(s => s.size === 'S6M')?.quantity || '',
      //   S2Y: item.sizes.find(s => s.size === 'S2Y')?.quantity || '',
      //   M12M: item.sizes.find(s => s.size === 'M12M')?.quantity || '',
      //   M4Y: item.sizes.find(s => s.size === 'M4Y')?.quantity || '',
      //   L12M: item.sizes.find(s => s.size === 'L12M')?.quantity || '',
      //   L6Y: item.sizes.find(s => s.size === 'L6Y')?.quantity || '',
      //   XL: item.sizes.find(s => s.size === 'XL')?.quantity || '',
      //   '2XL': item.sizes.find(s => s.size === '2XL')?.quantity || '',
      //   '3XL': item.sizes.find(s => s.size === '3XL')?.quantity || '',
      //   MIX: item.sizes.find(s => s.size === 'MIX')?.quantity || '',

      //   XS_in_hand: item.stock.sizes.find(s => s.size === 'XS')?.quantity_in_hand || 0,
      //   S6M_in_hand: item.stock.sizes.find(s => s.size === 'S6M')?.quantity_in_hand || 0,
      //   S2Y_in_hand: item.stock.sizes.find(s => s.size === 'S2Y')?.quantity_in_hand || 0,
      //   M12M_in_hand: item.stock.sizes.find(s => s.size === 'M12M')?.quantity_in_hand || 0,
      //   M4Y_in_hand: item.stock.sizes.find(s => s.size === 'M4Y')?.quantity_in_hand || 0,
      //   L12M_in_hand: item.stock.sizes.find(s => s.size === 'L12M')?.quantity_in_hand || 0,
      //   L6Y_in_hand: item.stock.sizes.find(s => s.size === 'L6Y')?.quantity_in_hand || 0,
      //   XL_in_hand: item.stock.sizes.find(s => s.size === 'XL')?.quantity_in_hand || 0,
      //   '2XL_in_hand': item.stock.sizes.find(s => s.size === '2XL')?.quantity_in_hand || 0,
      //   '3XL_in_hand': item.stock.sizes.find(s => s.size === '3XL')?.quantity_in_hand || 0,
      //   MIX_in_hand: item.stock.sizes.find(s => s.size === 'MIX')?.quantity_in_hand || 0,

      //   quantity_in_hand: item.stock.sizes.reduce(
      //     (total, sizeData) => total + (sizeData.quantity_in_hand || 0),
      //     0
      //   ),
      //   price: item.price,
      //   stock: item.stock._id,
      //   total: item.price * item.sizes.reduce((acc, size) => acc + size.quantity, 0)
      // });

      acc[key].items.push({
        color: item.stock.color,
        XS: item.sizes.find(s => s.size === 'XS')?.quantity || '',
        S: item.sizes.find(s => s.size === 'S')?.quantity || '',
        M: item.sizes.find(s => s.size === 'M')?.quantity || '',
        L: item.sizes.find(s => s.size === 'L')?.quantity || '',
        XL: item.sizes.find(s => s.size === 'XL')?.quantity || '',
        '2XL': item.sizes.find(s => s.size === '2XL')?.quantity || '',
        '3XL': item.sizes.find(s => s.size === '3XL')?.quantity || '',

        MIX: item.sizes.find(s => s.size === 'MIX')?.quantity || '',
        xS_in_hand: item.stock.sizes.find(s => s.size === 'XS')?.quantity_in_hand || 0,
        S_in_hand: item.stock.sizes.find(s => s.size === 'S')?.quantity_in_hand || 0,
        M_in_hand: item.stock.sizes.find(s => s.size === 'M')?.quantity_in_hand || 0,
        L_in_hand: item.stock.sizes.find(s => s.size === 'L')?.quantity_in_hand || 0,
        XL_in_hand: item.stock.sizes.find(s => s.size === 'XL')?.quantity_in_hand || 0,
        '2XL_in_hand': item.stock.sizes.find(s => s.size === '2XL')?.quantity_in_hand || 0,
        '3XL_in_hand': item.stock.sizes.find(s => s.size === '3XL')?.quantity_in_hand || 0,

        MIX_in_hand: item.stock.sizes.find(s => s.size === 'MIX')?.quantity_in_hand || 0,
        quantity_in_hand: item.stock.sizes.reduce((total, sizeData) => total + (sizeData.quantity_in_hand || 0), 0),
        price: item.price,
        stock: item.stock._id,
        total: item.price * item.sizes.reduce((acc, size) => acc + size.quantity, 0)
      });
      return acc;
    }, {});

    const updatedForms = Object.values(groupedItems);

    setOrderForms(updatedForms);

    updatedForms.forEach((form, index) => {
      fetchPartySpecificOptions(form.party, index);
    });

    setOpenDialog(true);
    seteditOrderId(order._id);
    setIsEditing(true);
  };
  const fetchItemsByPstyle = async (partyId, pstyleId, formIndex) => {
    try {
      const itemsRes = await api.get(`inventory/items_party?party=${partyId}&pstyle=${pstyleId}`);

      setPartySpecificOptions(prev => {
        // Update only the items for the specific form
        const newPartyOptions = {
          ...prev,
          [formIndex]: {
            ...prev[formIndex],
            items: itemsRes.data.message || []
          }
        };
        return newPartyOptions;
      });
    } catch (error) {
      console.error('Error fetching items by p_style:', error);
      toast.error('Error fetching items for the selected p_style');
    }
  };
  const [payOpen, setPayOpen] = useState(false);
  const handlePay = async (order) => {
    setPayOpen(true);
    setSelectedOrder(order);
  }
  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', padding: 2 }}>
      <Navbar title="Orders" />
      {/* <Box
        marginTop={10}
        marginBottom={3}
        display="flex"
        justifyContent="space-between"
        alignItems="center"
      >

        <Box gap={1}
          display="flex"
          flexWrap="wrap"
          justifyContent="flex-start">
          {user?.role !== 'customer' && (
            <>
              <Box flex="1 1 200px" minWidth={200}>
                <CustomSelect
                  fullWidth
                  label="Filter by Customer"
                  value={selectedCustomer}
                  onChange={(e) =>
                    e.target.value !== 'All Customers'
                      ? setSelectedCustomer(e.target.value)
                      : setSelectedCustomer('')
                  }
                  options={[
                    { id: 'All Customers', name: 'All Customers' },
                    ...customers.map((customer) => ({
                      id: customer._id,
                      name: customer.name,
                    })),
                  ]}
                />
              </Box>

              <Box flex="1 1 200px" minWidth={150}>
                <CustomSelect
                  fullWidth
                  label="Filter by Order Status"
                  value={selectedStatus}
                  onChange={(e) =>
                    e.target.value !== 'All'
                      ? setSelectedStatus(e.target.value)
                      : setSelectedStatus('')
                  }
                  options={[
                    { id: 'All', name: 'All' },
                    { id: 'SHIPPED', name: 'SHIPPED' },
                    { id: 'PENDING', name: 'PENDING' },
                    { id: 'APPROVED', name: 'APPROVED' },
                    { id: 'CANCELLED', name: 'CANCELLED' },
                  ]}
                />
              </Box>

              <Box flex="1 1 200px" minWidth={200}>
                <CustomSelect
                  fullWidth
                  label="Filter by Payment Status"
                  value={selectedPayment}
                  onChange={(e) =>
                    e.target.value !== 'All'
                      ? setSelectedPayment(e.target.value)
                      : setSelectedPayment('')
                  }
                  options={[
                    { id: 'All', name: 'All' },
                    { id: 'PAID', name: 'PAID' },
                    { id: 'PENDING', name: 'PENDING' },
                  ]}
                />
              </Box>
              <Box flex="1 1 200px" minWidth={200}>
                <CustomSelect
                  fullWidth
                  label="Filter by Invoice"
                  value={selectedInvoice}
                  onChange={(e) =>
                    e.target.value !== 'All'
                      ? setSelectedInvoice(e.target.value)
                      : setSelectedInvoice('')
                  }
                  options={[
                    { id: 'All', name: 'All' },
                    { id: 'YES', name: 'YES' },
                    { id: 'NO', name: 'NO' },
                  ]}
                />
              </Box>
              <Box flex="1 1 200px" minWidth={200}>
                <TextField
                  fullWidth
                  label="From Date"
                  type="date"
                  InputLabelProps={{ shrink: true }}
                  value={fromDate}
                  onChange={(e) => setFromDate(e.target.value)}
                />
              </Box>
              <Box flex="1 1 200px" minWidth={200}>
                <TextField
                  fullWidth
                  label="To Date"
                  type="date"
                  InputLabelProps={{ shrink: true }}
                  value={toDate}
                  onChange={(e) => setToDate(e.target.value)}
                />
              </Box>
            </>
          )}
        </Box>
        {(user?.role === 'admin' || accessControl["add-order"] === true) && (
          <Button
            variant="contained"
            sx={{ backgroundColor: '#1abc9c', color: 'black' }}
            startIcon={<AddIcon />}
            onClick={handleOpenDialog}
          >
            Add Order
          </Button>
        )}
      </Box> */}
      <Box
        marginTop={10}
        marginBottom={3}
        display="flex"
        flexDirection={{ xs: "column", md: "row" }}
        justifyContent="space-between"
        alignItems={{ xs: "stretch", md: "center" }}
        gap={2}
      >
        {/* Filters */}
        <Grid container spacing={2} flex={1}>
          {user?.role !== "customer" && (
            <>
              {/* Customer Filter */}
              <Grid item xs={12} sm={6} md={4} lg={2}>
                <CustomSelect
                  fullWidth
                  label="Filter by Customer"
                  value={selectedCustomer}
                  onChange={(e) =>
                    e.target.value !== "All Customers"
                      ? setSelectedCustomer(e.target.value)
                      : setSelectedCustomer("")
                  }
                  options={[
                    { id: "All Customers", name: "All Customers" },
                    ...customers.map((customer) => ({
                      id: customer._id,
                      name: customer.name,
                    })),
                  ]}
                />
              </Grid>

              {/* Order Status */}
              <Grid item xs={12} sm={6} md={4} lg={2}>
                <CustomSelect
                  fullWidth
                  label="Filter by Order Status"
                  value={selectedStatus}
                  onChange={(e) =>
                    e.target.value !== "All"
                      ? setSelectedStatus(e.target.value)
                      : setSelectedStatus("")
                  }
                  options={[
                    { id: "All", name: "All" },
                    { id: "PENDING", name: "UNAPPROVED" },
                    { id: "APPROVED", name: "UNSHIPPED" },
                    { id: "SHIPPED", name: "SHIPPED" },
                    
                    { id: "CANCELLED", name: "CANCELLED" },
                  ]}
                />
              </Grid>

              {/* Payment Status */}
              <Grid item xs={12} sm={6} md={4} lg={2}>
                <CustomSelect
                  fullWidth
                  label="Filter by Payment Status"
                  value={selectedPayment}
                  onChange={(e) =>
                    e.target.value !== "All"
                      ? setSelectedPayment(e.target.value)
                      : setSelectedPayment("")
                  }
                  options={[
                    { id: "All", name: "All" },
                    { id: "PAID", name: "PAID" },
                    { id: "PENDING", name: "UNPAID" },
                    // { id: "PARTIALLY_PAID", name: "PARTIALLY PAID" },
                  ]}
                />
              </Grid>

              {/* Invoice */}
              <Grid item xs={12} sm={6} md={4} lg={2}>
                <CustomSelect
                  fullWidth
                  label="Filter by Invoice"
                  value={selectedInvoice}
                  onChange={(e) =>
                    e.target.value !== "All"
                      ? setSelectedInvoice(e.target.value)
                      : setSelectedInvoice("")
                  }
                  options={[
                    { id: "All", name: "All" },
                    { id: "YES", name: "Invoiced" },
                    { id: "NO", name: "Uninvoiced" },
                  ]}

                />
              </Grid>

              {/* From Date */}
              <Grid item xs={12} sm={6} md={4} lg={2}>
                <TextField
                  fullWidth
                  label="From Date"
                  type="date"
                  InputLabelProps={{ shrink: true }}
                  value={fromDate}
                  onChange={(e) => setFromDate(e.target.value)}
                />
              </Grid>

              {/* To Date */}
              <Grid item xs={12} sm={6} md={4} lg={2}>
                <TextField
                  fullWidth
                  label="To Date"
                  type="date"
                  InputLabelProps={{ shrink: true }}
                  value={toDate}
                  onChange={(e) => setToDate(e.target.value)}
                />
              </Grid>
            </>
          )}
        </Grid>

        {/* Add Order Button */}
        {(user?.role === "admin" || accessControl["add-order"] === true) && (
          <Button
            variant="contained"
            sx={{
              backgroundColor: "#1abc9c",
              color: "black",
              minWidth: 150,
              height: "100%",
              whiteSpace: "nowrap",
            }}
            startIcon={<AddIcon />}
            onClick={handleOpenDialog}
          >
            Add Order
          </Button>
        )}
      </Box>
      <TableContainer component={Paper} sx={{ boxShadow: 'none' }}>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell sx={{ backgroundColor: "#1abc9c", fontWeight: 'bold', whiteSpace: "nowrap" }} >Order #</TableCell>
              <TableCell sx={{ backgroundColor: "#1abc9c", fontWeight: 'bold', whiteSpace: "nowrap" }} >Invoice #</TableCell>

              <TableCell sx={{ backgroundColor: "#1abc9c", fontWeight: 'bold', whiteSpace: "nowrap" }}>Customer</TableCell>
              <TableCell sx={{ backgroundColor: "#1abc9c", fontWeight: 'bold', whiteSpace: "nowrap" }}>Date</TableCell>
              <TableCell sx={{ backgroundColor: "#1abc9c", fontWeight: 'bold', whiteSpace: "nowrap" }}>Amount</TableCell>
              <TableCell sx={{ backgroundColor: "#1abc9c", fontWeight: 'bold', whiteSpace: "nowrap", whiteSpace: "nowrap" }}>Amount Paid</TableCell>
              {/* 
              <TableCell sx={{ backgroundColor: "#1abc9c", fontWeight: 'bold',whiteSpace: "nowrap" }}>Status</TableCell>
              <TableCell sx={{ backgroundColor: "#1abc9c", fontWeight: 'bold',whiteSpace: "nowrap" }}>Payment Status</TableCell> */}
              <TableCell sx={{ backgroundColor: "#1abc9c", fontWeight: 'bold', whiteSpace: "nowrap" }}>Balance</TableCell>

              <TableCell sx={{ backgroundColor: "#1abc9c", fontWeight: 'bold', whiteSpace: "nowrap" }}>View Invoice</TableCell>
              <TableCell sx={{ backgroundColor: "#1abc9c", fontWeight: 'bold', whiteSpace: "nowrap" }}>View P.O</TableCell>
              <TableCell sx={{ backgroundColor: "#1abc9c", fontWeight: 'bold', whiteSpace: "nowrap", textAlign: 'center' }}>Actions</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {loading ? (
              <TableRow>
                <TableCell colSpan={8} style={{ textAlign: 'center' }}>
                  Loading...
                </TableCell>
              </TableRow>
            ) : orders.length > 0 ? (
              orders.map((order) => (
                <TableRow key={order._id}>

                  <TableCell>{order.orderId}</TableCell>
                  <TableCell>{order?.invoice_num || 'N/A'}</TableCell>
                  <TableCell>
                    {order.customer?.name || order.customer?.email || 'N/A'}
                  </TableCell>
                  <TableCell>
                    {new Date(order.createdAt).toLocaleDateString()}

                  </TableCell>
                  <TableCell>{order?.final_price}</TableCell>
                  <TableCell>{order?.amount_paid}</TableCell>
                  {/* <TableCell>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                      <Chip
                        label={order.status}
                        color={getStatusColor(order.status)}
                        size="small"
                      />
                    </Box>
                  </TableCell> */}
                  {/* <TableCell>
                    <Chip
                      label={order.payment_status}
                      color={
                        order.payment_status === 'PENDING' ? 'warning' :
                          order.payment_status === 'COMPLETED' ? 'success' :
                            'default'
                      }
                      size="small"
                    />
                  </TableCell> */}
                  <TableCell>{order?.balance}</TableCell>

                  <TableCell>
                    {
                      (user?.role === 'customer' || user?.role === 'admin') && (
                        <>
                          <Tooltip title="View Invoice" arrow>
                            <IconButton
                              disabled={!order?.invoice_gen && !order?.pdfPath?.length > 0}
                              onClick={() => downloadInvoice(order)}
                              sx={{
                                color: (order?.invoice_gen && order?.pdfPath?.length > 0) ? 'green' : (order?.invoice_gen && order?.pdfPath?.length === 0) ? 'blue' : 'primary.main',
                                '&:hover': {
                                  transform: 'scale(1.2)'
                                },
                                transition: 'all 0.2s',
                              }}
                            >
                              <PiInvoiceFill sx={{ fontSize: 28 }} />
                            </IconButton>
                          </Tooltip>
                        </>
                      )
                    }
                  </TableCell>
                  <TableCell>
                    {
                      (user?.role === 'customer' || user?.role === 'admin') && (
                        <>
                          <Tooltip title="View Order Details" arrow>
                            <IconButton
                              onClick={() => onOpenDetails(order)}
                              sx={{
                                color: 'primary.main',
                                '&:hover': {
                                  transform: 'scale(1.2)'
                                },
                                transition: 'all 0.2s',
                              }}
                            >
                              <RemoveRedEye sx={{ fontSize: 28, color: '#F3CA52' }} />
                            </IconButton>
                          </Tooltip>
                        </>
                      )
                    }
                  </TableCell>
                  {/* <TableCell>
                    <Box sx={{
                      display: 'flex',
                      justifyContent: 'center',
                      gap: 1
                    }}>
                      {(user?.role === 'admin' || accessControl["manage-order"] === true) && (
                        <>
                          {order.status === 'PENDING' && (
                            <>
                              {(user?.role === 'admin' || accessControl["manage-order"] === true) && <Tooltip title="Edit Order" arrow>
                                <IconButton
                                  onClick={() => handleEditOrder(order)}
                                  sx={{
                                    color: 'info.main',
                                    '&:hover': {
                                      bgcolor: 'info.light',
                                      transform: 'scale(1.1)'
                                    },
                                    transition: 'all 0.2s',
                                  }}
                                >
                                  <EditIcon sx={{ fontSize: 28 }} />
                                </IconButton>
                              </Tooltip>}
                              {(user?.role === 'admin' || accessControl["approve-order"] === true) && <Tooltip title="Approve Order" arrow>
                                <IconButton
                                  onClick={() => handleApproveOrder(order.orderId)}
                                  sx={{
                                    color: 'success.main',
                                    '&:hover': {
                                      bgcolor: 'success.light',
                                      transform: 'scale(1.1)'
                                    },
                                    transition: 'all 0.2s',
                                  }}
                                >
                                  <CheckCircleIcon sx={{ fontSize: 28 }} />
                                </IconButton>
                              </Tooltip>}
                              {(user?.role === 'admin' || accessControl["revert-order"] === true &&(order?.status==='PENDING' || order?.status==='APPROVED' || order?.status==='SHIPPED')) && <Tooltip title="Revert Order" arrow>
                                <IconButton
                                  onClick={() => handleCancelOrder(order.orderId)}
                                  sx={{
                                    color: 'error.main',
                                    '&:hover': {
                                      bgcolor: 'error.light',
                                      transform: 'scale(1.1)'
                                    },
                                    transition: 'all 0.2s',
                                  }}
                                >
                                  <Undo sx={{ fontSize: 28 }} />
                                </IconButton>
                              </Tooltip>}
                            </>
                          )}
                          <ShipOrderModal
                            open={shipModalOpen}
                            handleClose={() => setShipModalOpen(false)}
                            initialData={{ shipped_date: "", shipped_via: "" }}
                            onShip={handleShipOrder}
                          />
                          {order.status === 'APPROVED' && (
                            <>
                              {(user?.role === 'admin' || accessControl["ship-order"] === true) && <Tooltip title="Ship Order" arrow>
                                <IconButton
                                  onClick={() => handleShipOpen(order)}
                                  // onClick={() => handleShipOrder(order.orderId)}
                                  disabled={shippingOrders.has(order.orderId)}
                                  sx={{
                                    color: 'primary.main',
                                    '&:hover': {
                                      transform: 'scale(1.2)'
                                    },
                                    transition: 'all 0.2s',
                                    '&.Mui-disabled': {
                                      opacity: 0.5,
                                      color: 'primary.main'
                                    }
                                  }}
                                >
                                  <LocalShippingIcon sx={{ fontSize: 28 }} />
                                </IconButton>
                              </Tooltip>}
                              <Tooltip title="Revert Order" arrow>
                                <IconButton
                                  onClick={() => handleCancelOrder(order.orderId)}
                                  sx={{
                                    color: 'error.main',
                                    '&:hover': {
                                      bgcolor: 'error.light',
                                      transform: 'scale(1.1)'
                                    },
                                    transition: 'all 0.2s',
                                  }}
                                >
                                  <Undo sx={{ fontSize: 28 }} />
                                </IconButton>
                              </Tooltip>
                            </>
                          )}
                        </>
                      )}


                    </Box>
                  </TableCell> */}
                  <TableCell>
                    <Box
                      sx={{
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        gap: 1
                      }}
                    >
                      {
                        order?.status === "SHIPPED" && (
                          <Typography sx={{ alignItems: 'center', textAlign: 'center', fontSize: 14, color: 'green' }}>
                            {order?.balance === 0 ? "SHIPPED/PAID" : "SHIPPED"}
                          </Typography>
                        )
                      }


                      {(user?.role === 'admin' || accessControl["manage-order"] === true) && (
                        <>
                          {/* {(order?.payment_status === "PENDING" || order?.payment_status === "PARTIALLY_PAID") && order?.status !== "CANCELLED" && <Tooltip title="Pay" arrow>
                            <IconButton
                              onClick={() => handlePay(order)}
                              sx={{
                                color: 'info.main',
                                '&:hover': {
                                  bgcolor: 'info.light',
                                  transform: 'scale(1.1)'
                                },
                                transition: 'all 0.2s',
                              }}
                            >
                              <PiCurrencyDollar sx={{ fontSize: 28 }} />
                            </IconButton>
                          </Tooltip>} */}
                          {(order?.payment_status === "PENDING" || order?.payment_status === "PARTIALLY_PAID") &&
                            order?.status !== "CANCELLED" &&
                            parseFloat(order?.balance ?? 0) > 0 && (
                              <Tooltip title="Pay" arrow>
                                <IconButton
                                  onClick={() => handlePay(order)}
                                  sx={{
                                    color: 'info.main',
                                    '&:hover': {
                                      bgcolor: 'info.light',
                                      transform: 'scale(1.1)'
                                    },
                                    transition: 'all 0.2s',
                                  }}
                                >
                                  <PiCurrencyDollar sx={{ fontSize: 28 }} />
                                </IconButton>
                              </Tooltip>
                            )}

                          {/* PENDING actions */}
                          {order.status === 'PENDING' && (
                            <>
                              {(user?.role === 'admin' || accessControl["manage-order"] === true) && (
                                <>
                                  <Tooltip title="Edit Order" arrow>
                                    <IconButton
                                      onClick={() => handleEditOrder(order)}
                                      sx={{
                                        color: 'info.main',
                                        '&:hover': {
                                          bgcolor: 'info.light',
                                          transform: 'scale(1.1)'
                                        },
                                        transition: 'all 0.2s',
                                      }}
                                    >
                                      <EditIcon sx={{ fontSize: 28 }} />
                                    </IconButton>
                                  </Tooltip>
                                </>
                              )}

                              {(user?.role === 'admin' || accessControl["approve-order"] === true) && (
                                <Tooltip title="Approve Order" arrow>
                                  <IconButton
                                    onClick={() => handleApproveOrder(order.orderId)}
                                    sx={{
                                      color: 'success.main',
                                      '&:hover': {
                                        bgcolor: 'success.light',
                                        transform: 'scale(1.1)'
                                      },
                                      transition: 'all 0.2s',
                                    }}
                                  >
                                    <CheckCircleIcon sx={{ fontSize: 28 }} />
                                  </IconButton>
                                </Tooltip>
                              )}
                            </>
                          )}

                          {/* Revert button for all three statuses */}
                          {(user?.role === 'admin' || accessControl["revert-order"] === true) &&
                            ['PENDING', 'APPROVED', 'SHIPPED'].includes(order?.status) && (
                              <Tooltip title="Revert Order" arrow>
                                <IconButton
                                  onClick={() => handleCancelOrder(order.orderId)}
                                  sx={{
                                    color: 'error.main',
                                    '&:hover': {
                                      bgcolor: 'error.light',
                                      transform: 'scale(1.1)'
                                    },
                                    transition: 'all 0.2s',
                                  }}
                                >
                                  <Undo sx={{ fontSize: 28 }} />
                                </IconButton>
                              </Tooltip>
                            )}

                          {(user?.role === 'admin' || accessControl["manage-order"] === true) && (
                            <Tooltip title="Delete Order" arrow>
                              <IconButton
                                onClick={() => handleDeleteOrder(order._id)}
                                sx={{
                                  color: 'error.main',
                                  '&:hover': {
                                    bgcolor: 'error.light',
                                    transform: 'scale(1.1)'
                                  },
                                  transition: 'all 0.2s',
                                }}
                              >
                                <DeleteIcon sx={{ fontSize: 28 }} />
                              </IconButton>
                            </Tooltip>
                          )}

                          <ShipOrderModal
                            open={shipModalOpen}
                            handleClose={() => setShipModalOpen(false)}
                            initialData={{ shipped_date: "", shipped_via: "" }}
                            onShip={handleShipOrder}
                          />

                          {/* APPROVED actions */}
                          {order.status === 'APPROVED' && (
                            <>
                              {(user?.role === 'admin' || accessControl["ship-order"] === true) && (
                                <Tooltip title="Ship Order" arrow>
                                  <IconButton
                                    onClick={() => handleShipOpen(order)}
                                    disabled={shippingOrders.has(order.orderId)}
                                    sx={{
                                      color: 'primary.main',
                                      '&:hover': {
                                        transform: 'scale(1.2)'
                                      },
                                      transition: 'all 0.2s',
                                      '&.Mui-disabled': {
                                        opacity: 0.5,
                                        color: 'primary.main'
                                      }
                                    }}
                                  >
                                    <LocalShippingIcon sx={{ fontSize: 28 }} />
                                  </IconButton>
                                </Tooltip>
                              )}
                            </>
                          )}
                        </>
                      )}
                    </Box>
                  </TableCell>

                </TableRow>
              ))
            ) : (
              <TableRow>
                <TableCell colSpan={8} style={{ textAlign: 'center' }}>
                  No orders found.
                </TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
      </TableContainer>
      {openDetailsDialog && <OrderDetailsDialog open={openDetailsDialog} handleClose={() => setOpenDetailsDialog(false)} order={order} />}


      <Dialog
        open={openDialog}
        onClose={handleCloseDialog}
        maxWidth="lg"
        fullWidth
        PaperProps={{
          sx: {
            minHeight: '70vh',
            maxHeight: '85vh',
            width: '80%',
            padding: '16px'
          }
        }}
      >
        <DialogTitle
          sx={{
            fontSize: '1.4rem',
            fontWeight: 'bold',
            pb: 0.5
          }}
        >
          {isEditing ? 'Edit Order' : 'Place Order'}
        </DialogTitle>
        <DialogContent
          sx={{
            pt: 1,
            pb: 1,
            '&::-webkit-scrollbar': {
              width: '8px'
            },
            '&::-webkit-scrollbar-thumb': {
              backgroundColor: '#bdbdbd',
              borderRadius: '4px'
            }
          }}
        >
          {user?.role !== 'customer' && (
            <Box sx={{ mb: 3 }}>
              <CustomSelect
                label="Customer"
                value={selectedOrderCustomer}
                onChange={(e) => setSelectedOrderCustomer(e.target.value)}
                options={customers.map(customer => ({
                  id: customer._id,
                  name: customer.name
                }))}
                sx={{ minWidth: '100%' }}
              />
            </Box>
          )}

          {orderForms?.map((form, index) => (
            <Box key={index} sx={{ mt: 4, mb: 2, position: 'relative' }}>
              <Typography variant="h6" sx={{ mb: 2 }}>
                Order Form {index + 1}
                {orderForms.length > 1 && (
                  <IconButton
                    onClick={() => handleRemoveOrderForm(index)}
                    sx={{ position: 'absolute', right: 0, top: 0 }}
                  >
                    <DeleteIcon />
                  </IconButton>
                )}
              </Typography>

              <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
                <Box sx={{ display: 'flex', gap: 2 }}>
                  <CustomSelect
                    label="Party"
                    value={form.party}
                    onChange={(e) => handleOrderFieldChange(index, 'party', e.target.value)}
                    options={parties.map(party => ({
                      id: party._id,
                      name: party.name
                    }))}
                    sx={{ flex: 1 }}
                  />
                  {/* <CustomSelect
                    label="P Style/Style"
                    value={form.p_style}
                    onChange={(e) => handleOrderFieldChange(index, 'p_style', e.target.value)}
                    options={(partySpecificOptions[index]?.pStyles || []).map(p_style => ({
                      id: p_style._id,
                      name: p_style.name
                    }))}
                    sx={{ flex: 1 }}
                    disabled={!form.party}
                  /> */}
                  <CustomSelect
                    label="P Style/Style"
                    value={form.p_style}
                    onChange={(e) => {
                      const selectedPstyle = e.target.value;
                      handleOrderFieldChange(index, 'p_style', selectedPstyle);

                      // Call the new function to refetch items
                      if (selectedPstyle) {
                        fetchItemsByPstyle(form.party, selectedPstyle, index);
                      }
                    }}
                    options={(partySpecificOptions[index]?.pStyles || []).map(p_style => ({
                      id: p_style._id,
                      name: p_style.name
                    }))}
                    sx={{ flex: 1 }}
                    disabled={!form.party}
                  />
                </Box>

                {/* Style and Item row */}
                <Box sx={{ display: 'flex', gap: 2 }}>
                  {/* <CustomSelect
                    label="Style"
                    value={form.style}
                    onChange={(e) => handleOrderFieldChange(index, 'style', e.target.value)}
                    options={(partySpecificOptions[index]?.styles || []).map(style => ({
                      id: style._id,
                      name: style.name
                    }))}
                    sx={{ flex: 1 }}
                    disabled={!form.party}
                  /> */}
                  <CustomSelect
                    label="Item"
                    value={form.item}
                    onChange={(e) => handleOrderFieldChange(index, 'item', e.target.value)}
                    options={(partySpecificOptions[index]?.items || []).map(item => ({
                      id: item._id,
                      name: item.name
                    }))}
                    sx={{ flex: 1 }}
                    disabled={!form.party}
                  />
                </Box>

                <OrderItemsTable
                  items={form?.items}
                  handleItemChange={(itemIndex, field, value) => {
                    handleItemChange(index, itemIndex, field, value);
                  }}
                  handleRemoveItem={(itemIndex) => handleRemoveItem(index, itemIndex)}
                  formIndex={index}
                />
              </Box>
            </Box>
          ))}

          <Button
            variant="outlined"
            startIcon={<AddIcon />}
            onClick={handleAddOrderForm}
            sx={{ mt: 2 }}
          >
            Add new Item
          </Button>
        </DialogContent>
        <DialogActions sx={{ p: 1.5, pt: 0 }}>
          <Button
            onClick={handleCloseDialog}
            sx={{
              color: 'black'
            }}
          >
            Cancel
          </Button>
          <Button
            onClick={isEditing ? handleUpdateOrder : handleAddOrder}
            variant="contained"
            sx={{
              backgroundColor: "#1abc9c",
              color: 'black',
              '&:hover': {
                backgroundColor: "#1abc9c",
                opacity: 0.9
              }
            }}
          >
            {isEditing ? 'Update Order' : 'Add Order'}
          </Button>
        </DialogActions>
      </Dialog>

      <ApprovalModal
        open={approvalModalOpen}
        handleClose={() => {
          setApprovalModalOpen(false);
          resetApprovalSettings();
        }}
        orderId={selectedOrderId}
        initialSettings={{
          qst_calculation: qstEnabled,
          gst_calculation: gstEnabled,
          hst_calculation: hstEnabled,
          invoice_gen: generateInvoice,
          discount: parseInt(discount, 10) || 0,
          paid: false,
          remarks: approvalRemarks || ""
        }}
        onApprove={handleApproveWithSettings}
      />
      {/* <PaymentDialog
      open={payOpen}
      onClose={()=>setPayOpen(false)}
      onSubmit={()=>console.log("submited")}></PaymentDialog> */}
      <PaymentDialog
        open={payOpen}
        order={order}
        onClose={() => setPayOpen(false)}
        refresh={async()=>await fetchOrders(rppRef.current, customerRef?.current)}
        onSubmit={async (values) => {
          try {
            // If it's a full payment, lock amount = order.final_price
            const payload = {
              orderId: editOrderId, // this is your order id
              amount: values.fullPay ? order.final_price : values.amount,
              date: new Date().toISOString(), // or use user-selected date
            };

            const response = await api.put(
              "https://www.idealapis.biz/orders/update-amount-paid",
              payload
            );
            
            if (response.data) {
              console.log("Payment success:", response.data);
              
              toast.success("Order Shipped successfully");
              await fetchOrders(rppRef.current, customerRef?.current);
              // await fetchOrders(rppRef.current, customerRef?.current);
              setPayOpen(false);
            }
          } catch (error) {
            console.error("Payment failed:", error);
            alert("Failed to record payment ❌");
          }
        }}
      />

      <Box sx={{ display: 'flex', justifyContent: 'center', mt: 2, mb: 2, alignItems: 'center', gap: 2 }}>
        <Pagination
          count={totalPages}
          page={page}
          onChange={handlePageChange}
          color="primary"
          showFirstButton
          showLastButton
        />
        <CustomSelect
          label="Rows per page"
          value={rowsPerPage}
          onChange={handleChangeRowsPerPage}
          options={[
            // { id: 5, name: '5' },
            // { id: 10, name: '10' },
            // { id: 25, name: '25' },
            // { id: 50, name: '50' },
            { id: 100, name: '100' },
                        { id: 200, name: '200' },
                        { id: 300, name: '300' },
                        { id: 400, name: '400' },
                        { id: 500, name: '500' },
          ]}
          sx={{ minWidth: 120 }}
        />
      </Box>



      {/* Color Dialog */}
      <Dialog open={colorDialog.open} onClose={handleCloseColorDialog}>
        <DialogTitle>Add New Color</DialogTitle>
        <DialogContent>
          <TextField
            autoFocus
            margin="dense"
            label="Color Name"
            type="text"
            fullWidth
            value={colorDialog.name}
            onChange={(e) => setColorDialog(prev => ({ ...prev, name: e.target.value }))}
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseColorDialog}>Cancel</Button>
          <Button
            onClick={handleAddColor}
            variant="contained"
            color="primary"
          >
            Add
          </Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
};

export default Orders;
